'use client';

import React from 'react';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { Testimonials } from '@/features/client/Testimonials/Testimonials';

const TestimonialsPage = () => {
  return (
    <div>
      {' '}
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Testimonials"
          title="Testimonials"
          description="What Our Clients Are Saying"
        />
      </MainSectionLayout>
      <Section styles={{ paddingTop: 20 }} variant="secondary">
        <Container>
          <Testimonials />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default TestimonialsPage;
